const totalSegmentedPeopleConfig = (dataArray) => {
  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false,
      position: "bottom",
      align: "center",
      labels: {
        padding: 10,
      },
    },
  };

  const dataPie = {
    labels: [
      "Mujeres adultas mayores ",
      "Hombres adultos mayores",
      "Mujeres jóvenes y adultas",
      "Hombres jóvenes y adultos",
      "Niñas",
      "Niños",
    ],
    datasets: [
      {
        data: dataArray,
        backgroundColor: [
          "rgba(255,178,116,0.7)",
          "rgba(255,210,106,0.7)",
          "rgba(126,87,194,0.7)",
          "rgba(3,169,244,0.7)",
          "rgba(234,111,137,0.7)",
          "rgba(151,213,118,0.7)",


        ],
        hoverBackgroundColor: [
          "#FF8D1F",
          "#FFBD23",
          "rgba(126,87,194,1)",
          "rgba(3,169,244,1)",
          "rgba(234,111,137,1)",

          "rgba(151,213,118,1)",

        ],
        hoverBorderColor: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
      },
    ],
  };

  return {
    type: "doughnut",
    title: "Datos demográficos",
    subtitle: "Total de adultos mayores, jóvenes y adultos, niños y niñas",
    data: dataPie,
    options: {
      ...sharedOptions,
      elements: {
        arc: {
          borderWidth: 10,
        },
      },
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          display: false,
        },
      },
    },
  };
};

export default totalSegmentedPeopleConfig;
